<template>
  <div v-if="isDialogBeforeLeaveCreate!=true">

    <v-container>
      <v-row no-gutters>
                <v-col cols="6">
          <v-btn class="btnDraftOrPublish" color="primary" :disabled="cache.storyTitle.length<4" @click="uploadMedaFilesDraft()" >{{$t("saveDraft")}}</v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn class="btnDraftOrPublish" color="primary" :disabled="!areMissingRequirementToPublish" @click="uploadMediaFilesPublic()" >{{$t("publish")}}</v-btn>
        </v-col>
      </v-row>
      <v-row>
      </v-row>
    </v-container>
  </div>
  <div v-else >
    <v-container>
      <v-row>
        <v-col cols="6">
          <v-btn class="btnDraftOrPublish px-4" color="primary" text :disabled="cache.storyTitle.length<4" @click="uploadMedaFilesDraft()" >{{$t("saveDraft")}}</v-btn>
        </v-col>
        <!--v-col cols="4">
          <v-btn class="btnDraftOrPublish" color="primary" :disabled="areMissingRequirementToPublish==true" @click="uploadMediaFilesPublic()" >{{$t("publish")}}</v-btn>
        </!--v-col-->
        <v-col class="text-center" cols=6>
              <v-btn color="red darken-1 btnDraftOrPublish" text @click="goToHome()">
                {{$t("exit")}}
              </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    //button to publish or save a story
    //the minimum conditions for saving a story in draft is the title of the story
    //the minimum conditions for publish a story are 4 :title of the story, content !="", cover image, position on the map
    //if the story has been edited, this.cache.isStory is set with the id of the story and when you try to save them if this.cache.isStory is set, the story is overwritten
    //when saving a story in the db the media files are loaded first, an id is returned for each media file. and associated with the correct media type when saving the story
    name: "btnDraftOrPublish",
    data: () => ({
      apiUrl: process.env.VUE_APP_ROOT_API,
      strapiUrl: process.env.VUE_APP_ROOT_STRAPI,
      imageBlob: {},
      audioBlob: [],
      videoBlob: {},
      imageID:null,
      videoID:null,
      audioID:[],
      imagesID:[],
      attachmentsID:[]
    }),
    components: {},
    computed: {
      getTagsLength: {
        get: function () {
          return this.cache.tags.length
        }
      },
      //information of the logged in user
      //contains the user's position taken from the db
      getLoadingText: {
        get: function () {
          if (this.cache.checkboxPublic){
          return this.$i18n.t('yourStoryHasBeenPublishedSuccessfully');
          }
          return this.$i18n.t('yourStoryHasBeenSavedSuccessfully');
        }
      },
      getDraftText: {
        get: function () {
          return this.$i18n.t('yourStoryHasBeenSavedSuccessfully');
        }
      },
      getUser: {
        get: function () {
          return this.$store.getters.getUser;
        }
      },
      //storyTitle,content,marker  of a story before it is saved in the db
      cache: {
        get: function () {
          return this.$store.state.newStories
        },
        set: function (newValue) {
          this.$store.dispatch("setNewStories", newValue)
        }
      },
      //all mediafile

      tempMediaOnIndexDB: {
        get: function () {
          return this.$store.state.tempMediaOnIndexDB
        },
        //set: function(newValue) {
        //this.$store.dispatch("setTempMediaOnIndexDB", newValue)
        //}
      },

      //variable that enables the button to publish a story if all the requirements are met
      areMissingRequirementToPublish: function () {
        return (this.cache.storyTitle.length>4 &&
                (this.tempMediaOnIndexDB.imageObj.id) &&
                (this.cache.content[0].data.length>4) &&
                (this.cache.marker.lat && this.cache.marker.lng)&&
                (this.getTagsLength > 0))
      }
    },
    async mounted() {
      // check this.tempMediaOnIndexDB  if present, it loads all media into the cache file
      //Read from this.tempMediaOnIndexDB image audio and video


      if (this.tempMediaOnIndexDB.videoTitle != "") {
        await this.getFileFromIndexDB(this.tempMediaOnIndexDB.videoTitle).then(response => {
          this.$store.dispatch("addBlobVideoNewStories", response[0].blob)
          this.videoBlob.file = response[0].blob
          this.videoBlob.name = this.tempMediaOnIndexDB.videoTitle
          this.videoID = this.tempMediaOnIndexDB.videoID
          this.videoBlob.lastModified = new Date();
        })
      }

      /*
          this.audioBlob =[]
          for (const element of this.tempMediaOnIndexDB.audios){
            //console.log("btnDraftOrPublished this.tempMediaOnIndexDB.audios element",element)
            const audioArray = await this.getFileFromIndexDB(element.title).then(response=>{
            //console.log("btnDraftOrPublished response",response)
            this.$store.dispatch("addBlobAudioNewStories", response[0].blob)
            this.audioBlob.push(response[0].blob)
            this.audioBlob[this.audioBlob.length-1].name=element.title
            this.audioBlob[this.audioBlob.length-1].lastModified = new Date();
            console.log("this.audioBlob",this.audioBlob)
            }).then(()=>console.log("audioArray",audioArray))
          }
      */

      //read from indexed db and set ther value in cache
      this.$store.dispatch("setNewStories", this.cache)
      this.cache = this.$store.state.newStories
    },
    //all the information of a story before it is saved in the db
    //to pass information between the comoponents
    watch: {
      /*'$store.state.newStories': function () {
        this.cache = this.$store.state.newStories
      },*/
      '$store.state.tempMediaOnIndexDB.videoTitle': async function () {
        if (this.tempMediaOnIndexDB.videoTitle != null && this.tempMediaOnIndexDB.videoTitle != "") {
          const videoArray = await this.getFileFromIndexDB(this.tempMediaOnIndexDB.videoTitle).then(response => {
            this.videoBlob.file = response[0].blob
            this.videoBlob.name = this.tempMediaOnIndexDB.videoTitle
            this.videoBlob.lastModified = new Date();
          }).then(() => console.log("videoArray", videoArray))

        } else {
          this.videoBlob = null
        }
      },
      /*
            '$store.state.tempMediaOnIndexDB.audios.length': async function () {
            this.audioBlob=[]
            console.log("watch $store.state.tempMediaOnIndexDB.audios",this.$store.state.tempMediaOnIndexDB.audios)
              this.$store.state.tempMediaOnIndexDB.audios.forEach(async singleAudio=>{
                if (!singleAudio.id){
                  const audioArray=await this.getFileFromIndexDB(singleAudio.title).then(response=>{
                  this.audioBlob.push(response[0].blob)
                  }).then(()=>console.log("audioArray",audioArray))}
                  else{
                  this.audioBlob.push({id:singleAudio.id})
                  }
              })
            }
      */
    },
  props: {
    isDialogBeforeLeaveCreate: {
      type: Boolean,
      required: false
    }
  },
    methods: {
    // before exit from creating story
    goToHome: function () {
      this.$store.dispatch("clearNewStory")
      this.$indexdb.mediaFiles.clear()
      this.$store.dispatch("setDialogSaveBeforeExit", false)
      this.$router.push({name: 'home'})
    },
      //using file name as primary key I recover media files from indexdb
      getFileFromIndexDB: function (name) {
        return this.$indexdb.mediaFiles.where("name").equalsIgnoreCase(name).toArray()
      },
      uploadMediaFilesPublic(){
        this.cache.checkboxPublic = true
        this.uploadMediaFiles()
      },
      uploadMedaFilesDraft(){
        this.cache.checkboxPublic = false
        this.uploadMediaFiles()
      },

      async uploadMediaFiles(){
        this.$store.dispatch('setLoadingStory', {status:true,text:this.getLoadingText})

        this.imageID = this.tempMediaOnIndexDB.imageObj.id

        this.videoID = await this.uploadVideoFiles()

        await this.uploadAttachmentsFiles()

        await this.uploadAudioMediaFiles()

        await this.uploadImagesMediaFiles()

        await this.uploadStory();

      },

      //attachments
      async uploadAttachmentsFiles() {
        try {

          //crate the array of other files to upload
          this.attachmentsID = []

          if (this.tempMediaOnIndexDB.attachments.length > 0) {

            try {
              let new_files = false
              //upload mew attachments
              let form_data_attachments = new FormData();
              for (const element of this.tempMediaOnIndexDB.attachments) {
                if (!element.id) {
                  await this.getFileFromIndexDB(element.title).then(async response => {
                    form_data_attachments.append('files', response[0].blob, response[0].name)
                    new_files = true
                  })
                } else {
                  this.attachmentsID.push(parseInt(element.id,10))
                }
              }
              if (new_files) {
              let uploadedFiles = (await this.$axios.post(this.strapiUrl+"/upload",
                form_data_attachments, {
                  headers: {
                    "Authorization": `Bearer ${this.$store.getters.getAccessToken}`,
                    'Content-Type': 'multipart/form-data',
                  }
                },
              )).data
              for (let file of uploadedFiles){
                let attachmentResponse = await this.$axios.post(this.apiUrl+"/postMediaFile", {
                  "type": "other",
                  "title": file.name,
                  "description": null,
                  "user": parseInt(this.getUser.id, 10),
                  "media": file.id
                }, {
                  headers: {
                    "x-access-token": `Bearer ${this.$store.getters.getAccessToken}`
                  }
                })
                this.attachmentsID.push(parseInt(attachmentResponse.data.id,10))
              }
              }
            } catch (error) {
              this.$store.dispatch('setLoadingStory', {status:false,text:''})
              if (Object.prototype.hasOwnProperty.call(error.response.data.message[0], 'messages')) {
                throw error.response.data.message[0].messages[0].message;
              }
              throw error.response.data.message
            }
          }
          } catch (error) {
                        this.$store.dispatch('setLoadingStory', {status:false,text:""})
          console.log(error)
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: "storyError",
            active: true
          })
        }
        },


      //try to upload the AUDIOS
      async uploadAudioMediaFiles() {
        try {
          //crate the array of audio files to upload
          this.audioID = []
          if (this.tempMediaOnIndexDB.audios.length > 0) {
            let new_files = false
            try {
              //caricamento audio
              let form_data = new FormData();
              for (const element of this.tempMediaOnIndexDB.audios) {
                if (!element.id) {
                  await this.getFileFromIndexDB(element.title).then(async response => {
                    form_data.append('files', response[0].blob, response[0].name)
                    new_files = true
                  })
                } else {
                  this.audioID.push(parseInt(element.id,10))
                }
              }
              if (new_files) {
              let uploadedFiles = (await this.$axios.post(this.strapiUrl+"/upload",
                form_data, {
                  headers: {
                    "Authorization": `Bearer ${this.$store.getters.getAccessToken}`,
                    'Content-Type': 'multipart/form-data',
                  }
                },
              )).data

              for (let file of uploadedFiles){
                let audioResponse = await this.$axios.post(this.apiUrl+"/postMediaFile", {
                  "type": file.mime.split("/")[0], //per allegati metto other
                  "title": file.name,
                  "description": null,
                  "user": parseInt(this.getUser.id, 10),
                  "media": file.id
                }, {
                  headers: {
                    "x-access-token": `Bearer ${this.$store.getters.getAccessToken}`
                  }
                })
                let audiotempID = audioResponse.data.id
                this.audioID.push(parseInt(audiotempID,10))
              }
              }

            } catch (error) {
                this.$store.dispatch('setLoadingStory', {status:false,text:''})
              if (Object.prototype.hasOwnProperty.call(error.response.data.message[0], 'messages')) {
                throw error.response.data.message[0].messages[0].message;
              }
              throw error.response.data.message
            }
          }
          } catch (error) {
            this.$store.dispatch('setLoadingStory', {status:false,text:''})
            console.log(error)
            this.$store.dispatch("setSnackbar", {
              color: 'red',
              text: "storyError",
              active: true
            })
          }
        },

      //try to upload the USER IMAGES  other than cover image.
      async uploadImagesMediaFiles() {
        try {
          //crate the array of audio files to upload
          this.imagesID = []
          if (this.tempMediaOnIndexDB.images.length > 0) {
            let new_files = false
            try {
              //caricamento audio
              let form_data = new FormData();
              for (const element of this.tempMediaOnIndexDB.images) {
                if (!element.id) {
                  await this.getFileFromIndexDB(element.title).then(async response => {
                    form_data.append('files', response[0].blob, response[0].name)
                    new_files = true
                  })
                } else {
                  this.imagesID.push(parseInt(element.id,10))
                }
              }
              if (new_files) {
              let uploadedFiles = (await this.$axios.post(this.strapiUrl+"/upload",
                form_data, {
                  headers: {
                    "Authorization": `Bearer ${this.$store.getters.getAccessToken}`,
                    'Content-Type': 'multipart/form-data',
                  }
                },
              )).data

              for (let file of uploadedFiles){
                let imagesResponse = await this.$axios.post(this.apiUrl+"/postMediaFile", {
                  "type": file.mime.split("/")[0], //per allegati metto other
                  "title": file.name,
                  "description": null,
                  "user": parseInt(this.getUser.id, 10),
                  "media": file.id
                }, {
                  headers: {
                    "x-access-token": `Bearer ${this.$store.getters.getAccessToken}`
                  }
                })
                let imagestempID = imagesResponse.data.id
                this.imagesID.push(parseInt(imagestempID,10))
              }
              }

            } catch (error) {
                this.$store.dispatch('setLoadingStory', {status:false,text:''})
              if (Object.prototype.hasOwnProperty.call(error.response.data.message[0], 'messages')) {
                throw error.response.data.message[0].messages[0].message;
              }
              throw error.response.data.message
            }
          }
          } catch (error) {
            this.$store.dispatch('setLoadingStory', {status:false,text:''})
            console.log(error)
            this.$store.dispatch("setSnackbar", {
              color: 'red',
              text: "storyError",
              active: true
            })
          }
        },



        ////////////////////////////////////////////////////// end images upload /////////////////////////////

      async uploadStory() {
      try {
            //Push story on DB
            //postStory is for new story
            //putStory is for edit story

            let url
            if (Number.isInteger(parseInt(this.cache.isStoryID,10))) {
              url =this.apiUrl+"/putStory"
            }else {
              url = this.apiUrl+"/postStory"
            }
            //before write in the db i have to remove the propriety toggle
            this.cache.content.forEach(x => delete x.toggle )
            await this.$axios.post(url, {
                "id": parseInt(this.cache.isStoryID,10),
                "title": this.cache.storyTitle,
                "content": JSON.stringify(this.cache.content),
                "latitude": this.cache.marker.lat,
                "longitude": this.cache.marker.lng,
                "is_published": this.cache.checkboxPublic,
                "country": this.cache.country,
                "city": this.cache.city,
                "user": parseInt(this.getUser.id, 10),
                "tags": this.cache.tags,
                "cover_image": parseInt(this.tempMediaOnIndexDB.imageObj.id,10),
                "video": parseInt(this.videoID,10),
                "audios": this.audioID,
                "reactions": [],
                "attachments":this.attachmentsID,
                "story_connections": [],
                "KGArrayImg": this.cache.KGArrayImg,
                "KGArrayText":this.cache.KGArrayText,
                "images":this.imagesID,
                "language":this.$vuetify.lang.current

              }, {
                headers: {
                  "x-access-token": `Bearer ${this.$store.getters.getAccessToken}`
                }
              })
              let message
              if (this.cache.checkboxPublic) {
              message = "storySuccess"
              } else {
              message = "storyDraft"
              }
            //RESET cache when upload is successful
            this.cache = {
              isStoryID: null,
              imageFile: null,
              imageType: "image/jpeg",
              attachmentsFiles: [],
              attachmentsFilesRaw: [],
              attachmentsTypes: [],
              attachmentsFileTitles: [],
              audioFiles: [],
              audioFilesRaw: [],
              audioTypes: [],
              audioFileTitles: [],
              videoFileRaw: null,
              videoFile: null,
              videoType: "video/mp4",
              KGArrayImg:[],
              KGArrayText:[],
              images:[]
            }
                // save the current btn selection in store
            this.$store.dispatch('setIsCreatedOrviewStories',0)
            //this.$store.dispatch('setIsAllOrNearme',this.isAllOrNearme)
            this.$store.dispatch('setIsSavedOrPublished',this.cache.checkboxPublic)
            this.$store.dispatch("setNewStories", this.cache)
            this.$store.dispatch("clearNewStory")
            this.$indexdb.mediaFiles.clear();
            this.$store.dispatch('setLoadingStory', {status:false,text:''})
            this.$store.dispatch("setSnackbar", {
              color: 'green',
              text: message,
              active: true
            })

            this.goToHome()
            //clear
          } catch (error) {
            console.log(error);
            this.$store.dispatch('setLoadingStory', {status:false,text:''})
            setTimeout(this.$store.dispatch("setSnackbar", {
              color: 'red',
              text: "storyError",
              active: true
            }), 5000)
           this.goToHome()
          }


      },

      //return the id value of the uploaded video
      async uploadVideoFiles() {


        //if imageID is != null there is the image in the DB
        if (this.tempMediaOnIndexDB.videoID != null) {
          return this.tempMediaOnIndexDB.videoID
        }

        if (typeof this.videoBlob.name !='undefined' && typeof this.videoBlob.file !='undefined') {
          try {

            let form_data = new FormData();
            form_data.append('files', this.videoBlob.file, this.videoBlob.name)
            let uploadedFile = (await this.$axios.post(this.strapiUrl+"/upload",
              form_data, {
                headers: {
                  "Authorization": `Bearer ${this.$store.getters.getAccessToken}`,
                  'Content-Type': 'multipart/form-data',
                }
              },
            )).data[0];

            let videoResponse = await this.$axios.post(this.apiUrl+"/postMediaFile", {
              "type": uploadedFile.mime.split("/")[0],
              "title": uploadedFile.name,
              "description": null,
              "user": parseInt(this.getUser.id, 10),
              "media": uploadedFile.id
            }, {
              headers: {
                "x-access-token": `Bearer ${this.$store.getters.getAccessToken}`
              }
            })

            return videoResponse.data.id
          } catch (error) {
                        this.$store.dispatch('setLoadingStory', {status:false,text:''})
            console.error(error)
            if (Object.prototype.hasOwnProperty.call(error.response.data.message[0], 'messages')) {
              throw error.response.data.message[0].messages[0].message;
            }
            throw error.response.data.message
          }
        }

      },
  }
}
</script>

<style>
  .btnDraftOrPublish{
    font-size: 0.6rem!important;
    padding: 0px;
    border-radius: 999rem;
    text-transform: uppercase !important;
  }
</style>